module.exports = __webpack_public_path__ + "static/media/melvin.1ddf6fde.jpeg";